import styled from 'styled-components';

export const StyledDebugContainer = styled.div`
  padding: 24px;
  max-width: 800px;
  margin: 0 auto;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
`;

export const StyledSection = styled.div`
  margin-bottom: 24px;
  padding: 16px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
`;

export const StyledTitle = styled.h2`
  color: #1f2937;
  margin-bottom: 16px;
`;

export const StyledCode = styled.pre`
  background: #f8fafc;
  padding: 12px;
  border-radius: 6px;
  overflow-x: auto;
  font-size: 14px;
  color: #374151;
`;

export const StyledButton = styled.button`
  background: #6366f1;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  margin-right: 8px;
  margin-bottom: 8px;

  &:hover {
    background: #5856eb;
  }

  &:disabled {
    background: #9ca3af;
    cursor: not-allowed;
  }
`;

export const StyledStatus = styled.div<{ $type: 'success' | 'error' | 'info' }>`
  padding: 8px 12px;
  border-radius: 6px;
  margin: 8px 0;
  font-size: 14px;

  ${({ $type }) => {
    switch ($type) {
      case 'success':
        return `
          background: #d1fae5;
          color: #065f46;
          border: 1px solid #a7f3d0;
        `;
      case 'error':
        return `
          background: #fee2e2;
          color: #991b1b;
          border: 1px solid #fca5a5;
        `;
      case 'info':
      default:
        return `
          background: #dbeafe;
          color: #1e40af;
          border: 1px solid #93c5fd;
        `;
    }
  }}
`;
